import { create } from 'zustand';

type State = {
	facilityId: string;
};

type Actions = {
	setFacilityId: (facilityId: string) => void;
};

export const useFacilityIdStore = create<State & Actions>((set) => ({
	facilityId: '',
	setFacilityId: (facilityId) => set({ facilityId }),
}));
